import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.6793 3.45274C11.2456 2.40094 12.7544 2.40094 13.3207 3.45274L21.3094 18.2888C21.8475 19.2882 21.1237 20.5 19.9887 20.5H4.01133C2.87631 20.5 2.15251 19.2882 2.69062 18.2889L10.6793 3.45274Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M12 8.5V13.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <circle cx="12" cy="17" fill="currentColor" r="1.25" />
    </svg>
);

export default Icon;
